import { render } from "./LineTabs2x.vue?vue&type=template&id=5d92b06a"
import script from "./LineTabs2x.vue?vue&type=script&lang=ts"
export * from "./LineTabs2x.vue?vue&type=script&lang=ts"
script.render = render

export default script